import { TDate } from '@/hooks/common/useCountDown';
import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';
import { createWithEqualityFn } from 'zustand/traditional';

export type CountDownItem = {
    timeLeft: number;
    formattedRes: {
        days: number;
        hours: number;
        minutes: number;
        seconds: number;
        milliseconds: number;
    };
};

type CountDownState = {
    startIntervel: any;
    timeLeft: {
        [key: string]: number;
    };
    keyTimerMap: {
        [key: string]: number;
    };
};

export type StartIntervelProps = {
    target: number | TDate;
    interval: number;
    onEnd?: () => void;
    key: string | number; // key表示同一个定时器
};

const calcLeft = (target?: TDate) => {
    if (!target) {
        return 0;
    }
    // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
    const left = dayjs(target).valueOf() - Date.now();
    return left < 0 ? 0 : left;
};

export const useCountDownState = createWithEqualityFn<CountDownState>(
    set => ({
        startIntervel: (intervalOption: StartIntervelProps) => {
            const { target, interval, key } = intervalOption;
            const timer = setInterval(() => {
                const targetLeft = calcLeft(target);
                // 记录剩余时间
                set(state => ({
                    ...state,
                    timeLeft: {
                        ...state.timeLeft,
                        [key]: targetLeft,
                    },
                }));
                if (targetLeft === 0) {
                    clearInterval(timer);
                    set(state => {
                        return {
                            ...state,
                            timeLeft: {
                                ...state.timeLeft,
                                [key]: 0,
                            },
                            keyTimerMap: {
                                ...state.keyTimerMap,
                                [key]: undefined,
                            },
                        };
                    });
                }
            }, interval) as unknown as number;
            set(state => {
                // 当useCountDown配置更新时，清除该key的上一个定时器
                clearInterval(state.keyTimerMap[key]);
                return {
                    ...state,
                    keyTimerMap: {
                        ...state.keyTimerMap,
                        [key]: timer,
                    },
                };
            });
        },
        timeLeft: {},
        keyTimerMap: {},
    }),
    isEqual
);
